module.exports = __webpack_public_path__ + "img/IOT.3bf0e1c6.png";